export const projects = [
  {
    id: 1,
    name: "Space",
    photoQuery: "space",
    techStack: ["React", "React Router", "Sass"],
    description:
      "Experience the cosmos like never before with this space tourism brochure website. Built using React, React Router, Sass, and Flexbox, this captivating and seamless web experience showcases the wonders of space travel in style across mobile, tablet, and desktop devices. 🚀🌌",
    github: "https://github.com/RickyReyes/space-tourism-website",
    liveSite: "https://space-tourism-website-rickyreyes.vercel.app/",
  },
  {
    id: 2,
    name: "Audiophile",
    photoQuery: "audiophile",
    techStack: ["React", "React Router", "Sass"],
    description:
      "Discover the perfect harmony of audio excellence with this mock e-commerce audio electronics site. Crafted with input validation, seamless routing, and a sleek cart modal, this website delivers a delightful shopping experience for audiophiles and music enthusiasts alike. 🎧",
    github: "https://github.com/RickyReyes/audiophile",
    liveSite: "https://audiophile-pink.vercel.app/",
  },
  {
    id: 3,
    name: "Flags",
    photoQuery: "flags",
    techStack: ["React", "Material UI"],
    description:
      "Immerse yourself in the world of flags with my addictive flag game, built with Material UI and React, challenge yourself to identify the correct country name for each flag displayed, and embark on a thrilling journey of global knowledge and fun. Currently under construction. 🌍🎮",
    github: "https://github.com/RickyReyes/flag-game-react",
    liveSite: "https://flag-game-react-nine.vercel.app/",
  },
  {
    id: 3,
    name: "Dictionary",
    photoQuery: "dictionary",
    techStack: ["TypeScript", "REST API", "React"],
    description:
      "Developed using TypeScript, React, and the Free Dictionary REST API, this app offers an expansive collection of definitions, sentence examples, and synoynms, empowering you with language knowledge at your fingertips. 📘🔍",
    github: "https://github.com/RickyReyes/dictionary",
    liveSite: "https://dictionary-navy.vercel.app/",
  },
];
